import { BaseApiService } from '@shared/services/BaseApiService';

class EmailVerificationServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  check(params) {
    return this.http.post('/check', params);
  }
}

export const EmailVerificationService = new EmailVerificationServiceClass({
  api_version: 2,
  resource: 'client/email-verifications'
});
